import { apiRequest } from "../../../services/api";
import { IApiResponseGetDashboard } from "../type/dashboard";

export const getAdminDashboard = async (params?: {
  date?: string;
  spaPriceDate?: number;
  spaPriceBranchId?: string;
}): Promise<IApiResponseGetDashboard> => {
  const response = await apiRequest("GET", `/dashboards/admin`, { params });
  return response.data;
};

export const getClientDashboard = async (params?: {
  clientId: string;
}): Promise<IApiResponseGetDashboard> => {
  const response = await apiRequest("GET", `/dashboards/client`, { params });
  return response.data;
};

export const getAgentDashboard = async (params?: {
  agentId: string;
  spaPriceDate?: number;
  fileStatusDate?: string;
}): Promise<IApiResponseGetDashboard> => {
  const response = await apiRequest("GET", `/dashboards/agent`, { params });
  return response.data;
};

export const getStaffDashboard = async (params?: {
  staffId: string;
}): Promise<IApiResponseGetDashboard> => {
  const response = await apiRequest("GET", `/dashboards/staff`, { params });
  return response.data;
};

export const getLawyerDashboard = async (params?: {
  lawyerId: string;
  date?: string;
}): Promise<IApiResponseGetDashboard> => {
  const response = await apiRequest("GET", `/dashboards/lawyer`, { params });
  return response.data;
};

export const getBranchAdminDashboard = async (params?: {
  branchAdminId: string;
  date?: string;
  spaPriceDate?: number;
}): Promise<IApiResponseGetDashboard> => {
  const response = await apiRequest("GET", `/dashboards/branchAdmin`, {
    params,
  });
  return response.data;
};
